
export const CONTROLLER_NAMES = {
    User: 1,
    Roles: 2,
    ServiceType: 3,
    ServiceCategory: 4,
    MedicalPendingOrder: 5,
    ProviderRegistrationRequest: 8,
    AccommodationOrder: 9,
    Transactions: 10,
    TransportationOrder: 12,
    TourOrder: 13,
    MedicalOrder: 14,
    HospitalProfile: 15,
    Doctors: 16,
    DoctorProfile: 17,
    PatientRequest: 18,
    Chat: 19,
    BrokerReportsGroup: 20,
    BrokerReportsGroup: 21,
}

export const SERVICES_TYPES = {
    Medical: 1,
    Hotel: 2,
    Transportation: 3,
    Tour: 4,
    TeleConsultation: 5,
}


export const SERVICE_TYPES = {
    Medical: 1,
    Hotel: 2,
    Transportation: 3,
    Tour: 4,
    TeleConsultation: 5,
}


export const ROLES = {
    SUPER_ADMIN: 1,

}

export const HOTEL_TYPE = {
    Rooms: 1,
    Beds: 2,
}

export const REQUESTS_SCREENS = [
    { title: [SERVICES_TYPES.Medical], content: "hospitalOrders" },
    { title: [SERVICES_TYPES.Hotel], content: "hotelOrders" },
    { title: [SERVICES_TYPES.Transportation], content: "transportaionOrders" },
    { title: [SERVICES_TYPES.Tour], content: "tourOrders" },
    // { title: [SERVICES_TYPES.TeleConsultation], content: "teleConsultations" },
]

export const USER_ACTIONS = {
    GET: "canGet",
    POST: "canPost",
    UDPATE: "canEdit",
    DELETE: "canDelte"
}

export const Paths = {
    WebServer: 'https://htapi.jozoortech.com/public/Files/',
    DashboardServer: 'https://htapidash.jozoortech.com/public/Files/'
}

export const REQUEST_STATUS = {
    ReadyQuotation: 1,
    WaitingClearanceApproval: 2,
    WaitingPartialPayment: 3,
    PartialPaymentDone: 4,
    Done: 5,
    Rejected: 6,
    WaitingPayment: 7,
    NeedClearanceApproval: 8,
    PendingRequest: 9,
    waitingAvailableDates: 10,
    AvailableDatesReady: 11,
    BookingRequestDone: 12,
    BookingConfirmed: 13,
    AdditionalDocumentsRequired: 14,

}

